import axios from 'axios'
import { AUTH_HEADERS } from '../utils/config'

export default {
  sendForgotPassword (email) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}account/resetemail?email=${email}`, email, AUTH_HEADERS())
  },

  resetPassword (data, email) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}account/resetPassword`, data, AUTH_HEADERS())
  },
  resetPasswordAdmin (data) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}account/resetPasswordAdmin`, data, AUTH_HEADERS())
  }
}
